export default __webpack_public_path__ + "static/media/referralCode.c388bb63.png";